// @ts-strict-ignore
import {
  ACTION_TYPE_PLURAL,
  AREAS_OF_FOCUS,
  AREAS_OF_STUDY,
  EDUCATION_LEVELS,
  INTERNSHIP_FUNCTIONS,
  JOB_FUNCTIONS,
  LOCALES,
  ORG_TYPES,
  ORG_TYPES_ALLOW_TO_POST_VOLOPS,
  PAYMENT_LEVELS,
  PROFESSIONAL_LEVELS,
  VOLOP_FUNCTIONS,
  VOLOP_SOURCES,
  VOLOP_SOURCE_FOR_ACTION_TYPE,
} from 'utils/constants';
import { difference, removeKeys } from 'utils/functional';
import { levelOptionTitles, levelOptions } from 'utils/search/sidefilters';

const orgTypeFacet: SearchFacet = {
  id: 'orgTypeFacet',
  name: 'orgType',
  title: getText('Org Type'),
  type: 'array',
  options: levelOptions(ORG_TYPES),
  optionTitles: levelOptionTitles(ORG_TYPES),
};

export const MAIN_SEARCH_FACETS: Record<string, SearchFacet> = {
  locationTypeFacet: {
    id: 'locationTypeFacet',
    name: 'locationType',
    title: getText('Remote Preference'),
    type: 'array',
    options: ['ONSITE', 'HYBRID', 'REMOTE', 'REMOTE_TEMPORARY'],
    optionTitles: {
      ONSITE: getText('On-Site'),
      HYBRID: getText('Hybrid'),
      REMOTE: getText('Remote'),
      REMOTE_TEMPORARY: getText('Temporarily Remote'),
    },
    hideInSideFilter: true,
  },
  employmentTypeFacet: {
    id: 'employmentTypeFacet',
    name: 'jobType',
    title: getText('Job Type'),
    type: 'array',
    options: ['FULL_TIME', 'PART_TIME', 'TEMPORARY', 'CONTRACT'],
    optionTitles: {
      FULL_TIME: getText('Full Time'),
      PART_TIME: getText('Part Time'),
      TEMPORARY: getText('Temporary'),
      CONTRACT: getText('Contract'),
    },
  },
  hasLocationFacet: {
    id: 'hasLocationFacet',
    name: 'hasLocation',
    title: getText('Has Location'),
    type: 'boolean',
    options: ['YES', 'NO'],
    optionTitles: {
      YES: getText('Has Location'),
      NO: getText('No Location'),
    },
  },
  paymentFacet: {
    id: 'paymentFacet',
    name: 'payment',
    title: getText('Compensation'),
    type: 'array',
    options: levelOptions(PAYMENT_LEVELS),
    optionTitles: levelOptionTitles(PAYMENT_LEVELS),
  },
  educationFacet: {
    id: 'educationFacet',
    name: 'education',
    title: getText('Education Level'),
    type: 'array',
    options: levelOptions(EDUCATION_LEVELS),
    optionTitles: levelOptionTitles(EDUCATION_LEVELS),
  },
  actionTypeFacet: {
    id: 'actionTypeFacet',
    name: 'actionType',
    title: getText('Opportunity Type'),
    type: 'array',
    options: difference(levelOptions(ACTION_TYPE_PLURAL), ['NONE', 'OTHER']),
    optionTitles: removeKeys(levelOptionTitles(ACTION_TYPE_PLURAL), [
      'NONE',
      'OTHER',
    ]),
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ id: string; name: string; title: string; t... Remove this comment to see the full error message
    facetToResetOnChange: 'volopSourceFacet',
    includeAdditionalOption: {
      VOLOP: 'OTHER',
    },
  },
  professionalLevelFacet: {
    id: 'professionalLevelFacet',
    name: 'professionalLevel',
    title: getText('Experience Level'),
    type: 'array',
    options: levelOptions(PROFESSIONAL_LEVELS),
    optionTitles: levelOptionTitles(PROFESSIONAL_LEVELS),
  },
  localeFacet: {
    id: 'localeFacet',
    name: 'locale',
    title: getText('Listing Language'),
    type: 'array',
    options: levelOptions(LOCALES),
    optionTitles: levelOptionTitles(LOCALES),
  },
  actionDateFacet: {
    id: 'actionDateFacet',
    name: 'actionDate',
    names: ['endsGT', 'startsLT'],
    title: getText('Date'),
    type: 'date',
    // Do not apply to date filters
    options: [],
    optionTitles: {},
  },
  orgTypeFacet,
  volopOrgTypeFacet: {
    ...orgTypeFacet,
    id: 'volopOrgTypeFacet',
    options: levelOptions(ORG_TYPES_ALLOW_TO_POST_VOLOPS),
    optionTitles: levelOptionTitles(ORG_TYPES_ALLOW_TO_POST_VOLOPS),
  },
  jobKeywordsFacet: {
    id: 'jobKeywordsFacet',
    name: 'functions',
    title: getText('Job Function'),
    type: 'array',
    options: Object.keys(JOB_FUNCTIONS),
    optionTitles: JOB_FUNCTIONS,
  },
  internshipKeywordsFacet: {
    id: 'internshipKeywordsFacet',
    name: 'functions',
    title: getText('Functions'),
    type: 'array',
    options: Object.keys(INTERNSHIP_FUNCTIONS),
    optionTitles: INTERNSHIP_FUNCTIONS,
  },
  volopKeywordsFacet: {
    id: 'volopKeywordsFacet',
    name: 'functions',
    title: getText('Skills'),
    type: 'array',
    options: Object.keys(VOLOP_FUNCTIONS),
    optionTitles: VOLOP_FUNCTIONS,
  },
  orgAreasOfFocusFacet: {
    id: 'orgAreasOfFocusFacet',
    name: 'areasOfFocus',
    title: getText('Issue Areas'),
    type: 'array',
    options: Object.keys(AREAS_OF_FOCUS),
    optionTitles: AREAS_OF_FOCUS,
  },
  volopAreasOfFocusFacet: {
    id: 'volopAreasOfFocusFacet',
    name: 'areasOfFocus',
    title: getText('Issue Areas'),
    type: 'array',
    options: Object.keys(AREAS_OF_FOCUS),
    optionTitles: AREAS_OF_FOCUS,
  },
  volopSourceFacet: {
    id: 'volopSourceFacet',
    name: 'source',
    title: getText('Source'),
    type: 'array',
    options: Object.keys(VOLOP_SOURCES),
    optionTitles: VOLOP_SOURCES,
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ id: string; name: string; title: string; t... Remove this comment to see the full error message
    optionCullFn: (filters) => {
      const actionTypeFacet = filters.actionType || filters.actionTypeFacet;
      const allFiltersSelected =
        actionTypeFacet instanceof Array &&
        actionTypeFacet.length ===
          MAIN_SEARCH_FACETS.actionTypeFacet.options.length;

      if (!allFiltersSelected) {
        const sources = new Set();
        actionTypeFacet.forEach((facet) => {
          VOLOP_SOURCE_FOR_ACTION_TYPE[facet].forEach((source) => {
            sources.add(source);
          });
        });
        return Array.from(sources).filter((source) => source !== 'NONE');
      }

      return Object.keys(VOLOP_SOURCES);
    },
  },
  publicPrivateFacet: {
    id: 'publicPrivateFacet',
    name: 'isPublicSchool',
    title: getText('Public / Private'),
    type: 'boolean',
    options: ['YES', 'NO'],
    optionTitles: {
      YES: getText('Public'),
      NO: getText('Private'),
    },
  },
  gradAreasOfStudyFacet: {
    id: 'gradAreasOfStudyFacet',
    name: 'areasOfStudy',
    title: getText('Areas of Study'),
    type: 'array',
    options: Object.keys(AREAS_OF_STUDY),
    optionTitles: AREAS_OF_STUDY,
  },
  jobFamilyFacet: {
    id: 'jobFamilyFacet',
    name: 'compdb.familyId',
    title: getText('Similar Jobs'),
    type: 'array',
    options: ['DUMMY_OPTION'],
    optionTitles: {},
    lazy: true,
    hideInSideFilter: true,
  },
};
